import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const LiveScores = loadable(() => pMinDelay(import('./LiveScores'), 300), {
  fallback: <Loading />
});

const AsyncLiveScores = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} bg-green`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <LiveScores { ...props } />
    </ApplicationLayout>
  );
};

AsyncLiveScores.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLiveScores;
